<output class="table-empty-state" aria-live="polite">
  @if (icon) {
    <div class="empty-state-icon-wrapper">
      <mat-icon class="empty-state-icon material-icons-outlined">
        {{ icon }}
      </mat-icon>
    </div>
  }

  <h3 class="empty-state-title">{{ title }}</h3>

  @if (message) {
    <p class="empty-state-message">{{ message }}</p>
  }
  @if (actionLabel) {
    <button
      mat-raised-button
      color="primary"
      class="empty-state-action"
      (click)="onActionClick()"
      [attr.aria-label]="actionLabel"
    >
      @if (actionIcon) {
        <mat-icon class="material-icons-outlined">{{ actionIcon }}</mat-icon>
      }
      {{ actionLabel }}
    </button>
  }
</output>
